import { IProjectCompanyOption } from '@company/projectCompany/projectCompany.models';
import { useProjectId } from '@config/config.hooks';
import { ContentLoader, IOption } from '@gcl/react-core';
import {
  useGetGlobalProjectRolesWithUserAsync,
  useGetProjectRolesWithUser,
} from '@role/projectRole/projectRole.queries';
import { useGetProjectTeamsWithUserAsync } from '@projectTeam/projectTeam.queries';
import { IProjectTeam } from '@projectTeam/projectTeam.models';
import * as React from 'react';
import { IProjectUserProfile } from '@userProfile/projectUserProfile.models';
import { ApiErrorDisplay } from '@core/ApiErrorDisplay';
import { UserTable } from './UserTable';
import { OPTION_KEY_GLOBALE_PROJECT_USERS, TTeamDisplayMode } from '../userList.constants';

interface IUserTableContainerProps {
  companyOption?: IOption<IProjectCompanyOption>;
  isDirtyMemberForm: boolean;
  hasEditRight: boolean;

  setSelectedTeam: React.Dispatch<React.SetStateAction<IProjectTeam | undefined>>;
  openConfirmDeleteTeamPortal: (e: any) => void;
  openTeamModal?: (e: any) => void;
  openMemberModal: (e: any, userProfile?: IProjectUserProfile) => void;
  setSelectedCompanyForForm?: React.Dispatch<React.SetStateAction<IOption<IProjectCompanyOption> | undefined>>;
  teamDisplayMode: TTeamDisplayMode;
  colNum?: number;
}
export const UserTableContainer = ({
  companyOption,
  isDirtyMemberForm,
  hasEditRight,

  setSelectedTeam,
  openConfirmDeleteTeamPortal,
  openTeamModal,
  openMemberModal,

  setSelectedCompanyForForm,
  teamDisplayMode,
  colNum,
}: IUserTableContainerProps) => {
  const projectId = useProjectId();

  const {
    data: globalRoles,
    isLoading: isLoadingGlobalRoles,
    isRefetching: isRefetchingGlobalRoles,
    error: errorGlobalRoles,
  } = useGetGlobalProjectRolesWithUserAsync(companyOption?.key === OPTION_KEY_GLOBALE_PROJECT_USERS);

  const {
    data: roles,
    isLoading: isLoadingRoles,
    isRefetching: isRefetchingRoles,
    error: errorRoles,
  } = useGetProjectRolesWithUser(
    {
      projectId,
      companyId: companyOption?.data?.id || 0,
    },
    !isDirtyMemberForm,
  );

  const {
    data: teams,
    isLoading: isLoadingTeams,
    isRefetching: isRefetchingTeams,
    error: errorTeams,
  } = useGetProjectTeamsWithUserAsync(
    {
      projectId,
      companyId: companyOption?.data?.id || 0,
    },
    !isDirtyMemberForm,
  );

  return (
    <>
      <ApiErrorDisplay
        errors={[
          { error: errorTeams, genericError: 'Get teams failed' },
          { error: errorGlobalRoles, genericError: 'Get global roles failed' },
          { error: errorRoles, genericError: 'Get roles failed' },
        ]}
      />
      <ContentLoader
        active={
          companyOption?.key === OPTION_KEY_GLOBALE_PROJECT_USERS
            ? isLoadingGlobalRoles
            : isLoadingRoles || isLoadingTeams
        }
        linePadding={10}
        paragraphConfigs={[{ suffixBlankRow: false, numberOfRows: 5, lineHeight: 10 }]}
      >
        <UserTable
          colNum={colNum}
          hasEditRight={hasEditRight}
          setSelectedCompanyForForm={
            setSelectedCompanyForForm
              ? () => {
                  setSelectedCompanyForForm(companyOption);
                }
              : undefined
          }
          roles={companyOption?.key !== OPTION_KEY_GLOBALE_PROJECT_USERS ? roles : globalRoles}
          teams={companyOption?.key !== OPTION_KEY_GLOBALE_PROJECT_USERS ? teams : []}
          teamDisplayMode={companyOption?.key === OPTION_KEY_GLOBALE_PROJECT_USERS ? 'companyGlobal' : teamDisplayMode}
          openTeamModal={openTeamModal}
          openConfirmDeleteTeamPortal={openConfirmDeleteTeamPortal}
          setSelectedTeam={setSelectedTeam}
          openMemberModal={openMemberModal}
        />
      </ContentLoader>
    </>
  );
};
